<template>
  <div>
    <template v-if="type === 'available_countries' && isAllCountriesSelected(list)">
      All
    </template>

    <template v-else-if="notEmptyList">
      <el-tag
        v-for="(item, i) in list"
        :key="i"
      >{{ item }}</el-tag>
    </template>

    <template v-else>/</template>
  </div>
</template>

<script>
import { createComponent, computed } from '@vue/composition-api'

import { countryList } from '../../utils/form'

const ListDataColumn = createComponent({
  props: {
    list: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  setup({ list }) {
    const notEmptyList = computed(() => list.length > 0)
    const isAllCountriesSelected = data => data.length === countryList.length

    return {
      notEmptyList,
      isAllCountriesSelected,
    }
  },
})

export default ListDataColumn
</script>
